import {
  Box,
  Button,
  Checkbox,
  Divider,
  Modal,
  Radio,
  RadioGroup,
  Stack,
} from "@mantine/core";
import React, { useMemo, useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { IconChevronDown } from "@tabler/icons-react";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../../../stores/LeadsStore";

const LeadsColumnChangerMobile = () => {
  const lang = useLanguage((s) => s.language);
  const containers = useLeadsContainerStore((s) => s.containers);
  const query = useLeadsStore((s) => s.query);
  const mobile_searchAll = useLeadsStore((s) => s.mobile_searchAll);
  const setMobile_searchAll = useLeadsStore((s) => s.setMobile_searchAll);
  const mobile_activeContainer = useLeadsStore((s) => s.mobile_activeContainer);
  const setMobile_activeContainer = useLeadsStore(
    (s) => s.setMobile_activeContainer
  );
  const activeContainer = useMemo(() => {
    return containers.find((x) => x.id === mobile_activeContainer?.id);
  }, [containers, mobile_activeContainer?.id]);

  const [opened, setOpened] = useState(false);
  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  const handleChange = (columnId) => {
    setMobile_activeContainer(containers.find((x) => x.id === columnId));
    if (query) {
      setMobile_searchAll(false);
    }
    handleClose();
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        radius={"md"}
        variant={"subtle"}
        className="test"
        style={{
          borderColor: "var(--mantine-color-primary-0)",
          background: "#fff",
        }}
        rightSection={<IconChevronDown size={16} />}
        mr={16}
      >
        {activeContainer?.name}
      </Button>

      <Modal opened={opened} onClose={handleClose} title={"Colonne"}>
        <Stack gap={0} w={"100%"}>
          {containers.map((column, i) => (
            <Box key={column.id} mt={8} w={"100%"}>
              <Checkbox
                size="md"
                label={`${column.name}`}
                checked={
                  query && mobile_searchAll
                    ? false
                    : mobile_activeContainer?.id === column.id
                }
                onChange={(e) => handleChange(column.id)}
                styles={{ labelWrapper: { flex: 1 } }}
              />
              <Divider mt={8} opacity={0.2} />
            </Box>
          ))}
        </Stack>
      </Modal>
    </>
  );
};

export default LeadsColumnChangerMobile;
